import { memo } from "react";
import { Select, SelectProps } from "antd";

const UserSelect = memo(({ ...rest }: SelectProps) => (
  <Select
    listItemHeight={72}
    virtual={false}
    notFoundContent={null}
    filterOption={false}
    showSearch
    optionLabelProp="inputLabel"
    popupClassName="user-suggestions-popup"
    popupMatchSelectWidth
    {...rest}
  />
));

export default UserSelect;
